import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../environments/environment";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import * as _ from 'underscore';
const BASE_URL = environment.BASE_URL;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json','source':"Website",'tp-inq-key':'8f6d8230e79bc464d4610d4021d71d438dd41151' })
};
@Injectable()
export class DataService {
  bDisableScreen: any = false;
  constructor(private http: HttpClient) { }

  sendEmail(requestJson): Observable<any> {
    return this.http.post(BASE_URL + 'sendEmail', requestJson, httpOptions)
      .map(this.returnJsonResponse)
      .catch(this.handleErrorObservable)
  }

  private returnJsonResponse(res: any) {
    return res;
  }
  private handleErrorObservable(error: any) {
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// /home/itheunrealist/techpixels/src/app/data.service.ts